import { ReservationOfferChannel } from '@pwp-common';

import { ReservationOfferEditorOutput } from './reservation-offer-editor-output';

export const defaultReservationOfferEditorOutput: ReservationOfferEditorOutput = {
  channel: ReservationOfferChannel.phoneCall,
  delay: 'P0D',
};
